import { helper } from '@ember/component/helper';
import { PillDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
function getPillVariant([pillVariant]) {
  switch (pillVariant) {
    case PillDescription.PillVariant.PILL_VARIANT_ALPHA:
      return 'alpha';
    case PillDescription.PillVariant.PILL_VARIANT_BETA:
      return 'beta';
    case PillDescription.PillVariant.PILL_VARIANT_CRITICAL:
      return 'critical';
    case PillDescription.PillVariant.PILL_VARIANT_DEFERRED:
      return 'deferred';
    case PillDescription.PillVariant.PILL_VARIANT_EMPHASIS:
      return 'emphasis';
    case PillDescription.PillVariant.PILL_VARIANT_INSIGHT:
      return 'insight';
    case PillDescription.PillVariant.PILL_VARIANT_NORMAL:
      return 'normal';
    case PillDescription.PillVariant.PILL_VARIANT_SUCCESS:
      return 'success';
    case PillDescription.PillVariant.PILL_VARIANT_WARNING:
      return 'warning';
  }
}
export default helper(getPillVariant);